<script type="text/ecmascript-6">
    import Question from "./mixin/Question.vue";

    export default {
        mixins: [
            Question,
        ],
        props: {
            title: {
                default(){
                    return 'Choose closer:';
                }
            },
            component_id: {
                default(){
                    return 'closer';
                }
            },
            typeRange: {
                default(){
                  return 0;
                }
            },
            openingDirection: {
                default(){
                    return 0;
                }
            },
        },
        computed: {
            passed_filter(){
                return this.variable_ready();
            },
            url(){
                return '/api/options/' + this.fabricator + '/closer?door_range=' + this.typeRange + '&opening_direction=' + this.openingDirection;
            },
            cache_key(){
                return '_' + this.fabricator + '_' + this.typeRange + '_' + this.openingDirection;
            }
        },
        watch: {
            'cache_key': function (val, oldVal) {
                this.update_options();
            },
        },
    }
</script>
